package com.xtream.data_kmp.di


import androidx.room3.Room
import androidx.sqlite.driver.web.WebWorkerSQLiteDriver
import com.xtream.data_kmp.db.AppRoomDB
import com.xtream.data_kmp.db.AppRoomDBConstructor
import com.xtream.data_kmp.db.DbMigrations.MIGRATION_29_30
import com.xtream.data_kmp.db.DbMigrations.MIGRATION_30_38
import com.xtream.data_kmp.db.DbMigrations.MIGRATION_38_39
import com.xtream.data_kmp.db.DbMigrations.MIGRATION_39_40
 import kotlinx.coroutines.Dispatchers
import org.koin.dsl.module
import org.w3c.dom.Worker

val webDatabaseModule = module {
    single<AppRoomDB> {

        Room.databaseBuilder<AppRoomDB>(
            name = "xtreamDatabase.db",
            factory = { AppRoomDBConstructor.initialize() } // CRITICAL

        )
            .setDriver( createWebSqlDriver())
            .setQueryCoroutineContext(Dispatchers.Default)
            //.setJournalMode(RoomDatabase.JournalMode.TRUNCATE)
            // ✅ safer for web

            .fallbackToDestructiveMigration(false)
            .addMigrations(MIGRATION_29_30, MIGRATION_30_38, MIGRATION_38_39 , MIGRATION_39_40)
            .build()
    }


    //single<DeviceInfo> { getDesktopDeviceInfo() }
}
//fun () =
  //   WebWorkerSQLiteDriver(Worker(js("""new URL("sql-js-worker/worker.js", import.meta.url)""")))

/**
 * Create a [WebWorkerSQLiteDriver] whose web worker implementation is `@androidx/sqlite-web-worker`
 * which itself utilizes SQLite WASM (`@sqlite.org/sqlite-wasm`) to persist the database in the
 * Origin-Private File System (OPFS).
 */
   fun createWebSqlDriver(): WebWorkerSQLiteDriver {
    return WebWorkerSQLiteDriver(
        Worker(js("""new URL("@androidx/sqlite-web-worker/worker.js", import.meta.url)"""),

            js("{ type: 'module' }")
        )
    )
}